
import CheckIcon from 'vux/src/components/check-icon/index.vue'

import Popup from 'vux/src/components/popup/index.vue'

import XTable from 'vux/src/components/x-table/index.vue'

export default {
name: "select-relate-flow",
components: {
Popup,
CheckIcon,
XTable,

},
data() {
return {
value: null,
list: [],
baseDto: [],
show: false,
isVisible: false,
showBottom: false,
page: 0,
chooseData:null
}
},






props:['url','searchCondition','item','multiple','searchBaseData','selectDataList'],
methods: {

showPop() {
this.show = true;
if(this.show){
this.page = 0;
this.showBottom = false;
this.value = null;
this.list = [];
if(this.selectDataList && this.selectDataList.length){
this.chooseData=this.selectDataList;
}else{
this.chooseData = null;
}
this.getList();
}
},
getList() {
let searchData = {firstResult: this.page, maxResult: 10};
if(this.value){
searchData[this.searchCondition['value']]=this.value;
}
if(this.searchBaseData){
searchData=Object.assign(searchData,this.searchBaseData)
}
this.$post(this.url,searchData).then(data => {
if(this.selectDataList.length){
if(data.content&& data.content.length){
this.chooseData.forEach(selected=>{
data.content.forEach(val=>{
if(selected.id==val.id){
this.$set(val,'checkSelected',true)
}
})
})

}
}
this.list = this.list.concat(data.content);
if(data.length < 10){
this.showBottom = true;
}else {
this.showBottom = false;
}
})
},
getMore(){
this.page++;
this.getList();
},

searchList(){
this.page = 0;
this.list = [];
this.chooseData = null;
this.getList();
},
choose(data){
if(this.multiple){
if(data.checkSelected){
if(!this.chooseData){
this.chooseData = [];
}
this.chooseData.push(data);
}else{
let dataList = [];
for(let i=0;i<this.chooseData.length;i++){
if(data.id !== this.chooseData[i].id){
dataList.push(this.chooseData[i]);
}
}
this.chooseData = dataList;
}
}else{
if(data.checkSelected){
if(this.chooseData){
this.$set(this.chooseData,'checkSelected',false);
}
this.chooseData = data;
}else{
this.chooseData = null;
}
}
},
deleteChooseData(i){
this.$set(this.chooseData[i],'checkSelected',false)
this.list.forEach(val=>{
if( val.id==this.chooseData[i].id){
this.$set(val,'checkSelected',false)
}
})
this.chooseData.splice(i,1)
},

goBack(){
this.$emit('getChoosed',this.chooseData)
this.show=!this.show;
}
}
}



// WEBPACK FOOTER //
// ./src/components/browse/select-relate-flow.vue